<template>
    <div>
      
      <h1 class="logo">
        <!--地理-->
        <span v-show="isGeo"><img src="static/images/common/logo-chiri.svg" :alt="title"></span>
        <!--歴史-->
        <span v-show="isHistory"><img src="static/images/common/logo-his.svg" :alt="title"></span>
        <!--公共-->
        <span v-show="isCivics"><img src="static/images/common/logo-pub.svg" :alt="title"></span>
      </h1>

      <nav class="header-nav">
        <div class="box-l">
          <button v-show="canBackFlagValue == '1'" class="btn btn-prev" href="#" v-on:click.prevent='prevAction'><img src="static/images/common/btn/btn-prev.svg" alt="戻る"></button>

          <button v-show="canBackFlagValue != '1'" class="btn btn-prev disabled"><img src="static/images/common/btn/btn-prev-disabled.svg" alt="戻る"></button>

        </div>
        
        <h2 class="ttl">
          <img :src="titleImage" :alt="title">
        </h2>

        <div class="box-r">
          <!--通常のホームボタン-->
          <button v-show="!isQuestion" class="btn btn-home" href="#" v-on:click.prevent='menuAction'><img src="static/images/common/btn/btn-home.svg" alt="ホーム"></button>
          
          <!--確認ダイアログ付のホームボタン（一問一答）-->
          <button v-show="isQuestion" class="btn btn-home" href="#" v-on:click.prevent='questionHomeAction' ><img src="static/images/common/btn/btn-home.svg" alt="ホーム"></button>
        </div>
      </nav>     

      <!--単元選択へ-->
      <div class="btn-unit-box" v-show="isQuestionDetail">
          <a href="#" class="btn btn-unit" data-remodal-target="confirmModal2"><img src="static/images/common/btn/btn-unit.svg" alt="単元選択へ"></a>
      </div>

      <!--確認ダイアログ1（メニューに戻る）-->
      <div id="confirmModal" data-remodal-id="confirmModal" class="remodal modal-box" data-remodal-options="hashTracking:false">
        <div class="modal-content">
          <div class="text-box">
            <p>これまでの正解情報はリセットされますがよろしいですか？</p>
          </div>
          <div class="btn-yesno-box">
            <div class="box-l">
              <button type="button" class="btn btn-yes" data-remodal-action="close" v-on:click.prevent='menuAction'><img src="static/images/common/btn/btn-yes.svg" alt="はい"></button>
            </div>
            <div class="box-r">
              <button data-remodal-action="close" type="button" class="btn btn-no"><img src="static/images/common/btn/btn-no.svg" alt="いいえ"></button>
            </div>
          </div>
        </div>
      </div>

      <!--確認ダイアログ2（単元トップに戻る）-->
      <div data-remodal-id="confirmModal2" class="remodal modal-box" data-remodal-options="hashTracking:false">
        <div class="modal-content">
          <div class="text-box">
            <p>これまでの正解情報はリセットされますがよろしいですか？</p>
          </div>
          <div class="btn-yesno-box">
            <div class="box-l">
              <button type="button" class="btn btn-yes" data-remodal-action="close" v-on:click.prevent='questionTopAction'><img src="static/images/common/btn/btn-yes.svg" alt="はい"></button>
            </div>
            <div class="box-r">
              <button data-remodal-action="close" type="button" class="btn btn-no"><img src="static/images/common/btn/btn-no.svg" alt="いいえ"></button>
            </div>
          </div>
        </div>
      </div>

    </div>

</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import router from '@/router'
import cmd from '@/common/Command'
import store from '@/store'

export default {
  props: [
    'titleImage',
    'canBackFlag',
    'isQuestionDetail'
  ],
  data: function () {
    return {
      title: process.env.TITLE,
      showMenuLink: store.state.currentMenu != "",
      canBackFlagValue: this.canBackFlag
    }
  },
  mounted: function () {
    
    //リロードまたは、URL直接指定の場合と一問一答の場合
    if (this.$store.state.currentMenu == "" || this.$store.state.currentMenu == "question") {
      //一問一答用モーダルライブラリを読み込み
      cmd.loadRemodal()
    }

  },
  methods: mapActions('HeaderModule', [
    'prevAction',
    'menuAction',
    'questionTopAction',
    'questionHomeAction'
  ]),
  computed: {
    ...mapGetters('HeaderModule', [
      'version',
      'isQuestion',
      'isGeo',
      'isHistory',
      'isCivics',
    ]),
    
  },
}
</script>



// WEBPACK FOOTER //
// src/components/modules/Header.vue